import Vue from 'vue';
import Amplitude from 'amplitudejs';
Object.defineProperty(Vue.prototype, '$amplitude', { value: Amplitude });
